// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__zzu9Q","main":"Layout_main__fiYlV"};